var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconOwnerRubleOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon-owner-ruble-outline_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M9.208 11.705h2.642v.827H9.208V14H8.04v-1.468H7v-.827h1.04v-.85H7v-.97h1.04V6h2.46c2.047 0 3.5.486 3.5 2.428 0 1.875-1.453 2.427-3.5 2.427H9.208zm1.35-1.82c1.246 0 2.252-.244 2.252-1.457S11.805 6.97 10.558 6.97h-1.35v2.913z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9.375,
  stroke: "#000",
  strokeWidth: 1.25
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-owner-ruble-outline_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgIconOwnerRubleOutline;